var app = angular.module("leonardo");

var ContactTypeListController = function ($scope, $state, ngDialog, $controller, ContactTypeRestService, AuthDataService,
                                          FilterService, PermissionService) {

  $scope.permissionService = PermissionService;

  $scope.authDataService = AuthDataService;

  $scope.getEntitiesPromise = function (options) {
    options.name = FilterService.getFilter('contact_type_name');
    options.sector = FilterService.getFilter('sector');
    return ContactTypeRestService.getlist(options);
  };

  $scope.showEditType = function (type) {
    ngDialog.open({
      controller: 'ContactTypeEditDialog',
      templateUrl: 'views/templates/dialog/contact/contact-type.html',
      data: {
        type: type
      }
    });
  };

  $scope.showDeleteType = function (type) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: type,
        type: 'contact type'
      }
    }).then(function(data){
      ContactTypeRestService.updateCollection(data, true);
      $scope.loadPage($scope.page);
    });
  };

  $controller('TableFilterController', {$scope: $scope});
  $scope.loadPage(1);

  $scope.$on('contact-type:changed', function () {
    $scope.loadPage($scope.page);
  });

};

app.controller('ContactTypeListController', ['$scope', '$state', 'ngDialog', '$controller', 'ContactTypeRestService',
  'AuthDataService', 'FilterService', 'PermissionService', ContactTypeListController]);
